import { appendStoredTrackingParamsToSearch } from './shopify-tracking-params';

const removeTrailingSlashes = (value: string) => value.replace(/\/+$/, '');
const hasProtocol = (value: string) => /^https?:\/\//i.test(value);

export const getShopifyHost = (): string => {
  const host = process.env.GATSBY_SHOPIFY_HOST || '';
  if (!host) {
    return '';
  }

  const absoluteHost = hasProtocol(host) ? host : `https://${host}`;
  return removeTrailingSlashes(absoluteHost);
};

export const buildShopifyRedirectUrl = (pathname: string, search = '', hash = ''): string | null => {
  const host = getShopifyHost();
  if (!host) {
    return null;
  }

  let normalizedPath = pathname.startsWith('/') ? pathname : `/${pathname}`;
  if (normalizedPath !== '/' && !normalizedPath.endsWith('/')) {
    normalizedPath += '/';
  }
  const normalizedSearch = appendStoredTrackingParamsToSearch(search);
  return `${host}${normalizedPath}${normalizedSearch}${hash}`;
};
